import React from 'react';
import roles from 'helpers/roles';
import withStyles from '@material-ui/core/styles/withStyles';
import { combineStyles } from 'helpers/helpers';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import getReportFileNameWithMultiplier from 'helpers/getReportFileNameWithMultiplier';

import CombinedReport from './CombinedReport/CombinedReport';
import MIME_TYPES from './constants/mimeTypes';

class RecipeIngredients extends React.Component {
  state = {
    eachRecipeOnNewPage: true,
    includeSubscriptions: false,
  };

  render() {
    const { t } = this.props;
    const title = t('reports.reportRecipeIngredients');

    return (
      <CombinedReport
        name="RECIPE_INGREDIENTS"
        title={title}
        url="reports/recipe-ingredients"
        previewXlsxAvailable={true}
        mimeTypes={[MIME_TYPES.xlsx]}
        fileName={params =>
          getReportFileNameWithMultiplier(
            params,
            this.props.t('common.mainMenu.reportsRecipeIngredients')
          )
        }
        role={roles.ROLE_SHOW_REPORT_RECIPES_INGREDIENTS}
        useDateRange={true}
        showMultiplier={true}
        validateBrands={false}
        validateDatePicker={true}
        archiveReportNames={['RECIPE_INGREDIENTS']}
        useZoneCategories={true}
        useSubBrands={true}
        useRecipeTags={true}
        singleSelectRecipeTags={true}
        isSalesMarketLangViewEnabled={true}
      />
    );
  }
}

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(withStyles(combinedStyles), withTranslation());

export default enhance(RecipeIngredients);
